<template>
  <div>
    <b-table
      thead-class="d-none"
      :tbody-td-attr="{ class: 'align-middle' }"
      fixed
      outlined
      :fields="fields"
      :items="reportsForTable"
      selected-variant="secondary">
      <template #cell(triennium)="{ item }">
        <div class="cursor-pointer" v-if="item">
          {{ `${item.triennium.from} - ${item.triennium.to}` }}
        </div>
      </template>

      <template #cell(actions)="{ item }">
        <a :href="mx_pdfLink(item)"
           target="_blank"
           class="btn btn-secondary"
           :class="{ disabled: item.reports[0].reportable.can.exportAwards === false}">
          Export Award Recommendations
        </a>

        <button type="button" class="btn btn-primary ml-4"
                :disabled="item.reports[0].reportable.can.closeAward === false"
                @click="setCurrentReport(item.reports[0])">
          <span v-if="item.reports[0].reportable.isClosed">Awards Closed</span>
          <span v-else>Close Awards</span>
        </button>
      </template>
    </b-table>
    <b-modal v-model="modalShow"
             title="Is the Award ready to be closed?"
             ok-title="Yes, close the award"
             cancel-title="No, not ready yet"
             @ok="handleCloseAward(currentReport.reportable.id)"
             @cancel="modalShow = false">
      Closing the Award is final.
      The list of Awardees will no longer be modified. The citations are final. You are expected to
      have obtained all required
      approvals by the relevant IFAC oﬃcials.
    </b-modal>
  </div>
</template>

<script>
import Awards from '@/services/Api/Awards/Awards';
import { mapState } from 'vuex';

export default {
  name: 'DecisionsReportsTable',
  props: {
    awardReports: Array,
  },
  data() {
    return {
      modalShow: false,
      currentReport: null,
      fields: [
        {
          key: 'triennium',
          label: '',
          tdClass: 'align-middle col-6',
        },
        {
          key: 'actions',
          label: '',
          tdClass: 'col-6 text-right',
        },
      ],
    };
  },
  methods: {
    setCurrentReport(report) {
        this.currentReport = report;
        this.modalShow = true;
    },
    handleCloseAward(awardId) {
      Awards.closeAward(awardId).then(() => {
        this.$emit('awardClosed', awardId);
      });
    },
    mx_pdfLink(item) {
      return `${this.mx_baseUrl}/awards/awards/export-recommendations?api_token=${this.mx_token}&triennium=${item.triennium.number}`;
    },
  },
  computed: {
    ...mapState({
      mx_token: (state) => state.auth?.tokens?.token,
    }),
    mx_baseUrl() {
      return process.env.VUE_APP_API_URL;
    },
    reportsForTable() {
      return Object.values(
        this.awardReports.reduce((result, item) => {
          // Check if the category group already exists in the result
          const award = item.reportable;

          if (!result[award.triennium.number]) {
            result[award.triennium.number] = { triennium: award.triennium, reports: [] };
          }

          // Push the item into the group's categories
          result[award.triennium.number].reports.push(item);

          return result;
        }, {}),
      );
    },
  },
};
</script>
